import { env, ENV_kEYS } from '@/utils';
import {
  init,
  setTimezone,
  isSupportedTimezone,
  getCapitalCity,
} from '@didi/elvish-lib-javascript';

const DEFAULT_CONFIG = {
  COUNTRY: 'MX',
  LOCALE: 'en-US',
  TIMEZONE: 'America/Mexico_City',
};

/**
 * @name 加特兰拼接locale：语言码-国家码
 */
function countryLocalMap(country, language) {
  const lang = language.split('-')[0];
  return `${lang}-${country}`;
}
/**
 * @name elvish初始化
 */
async function initElvish() {
  const userInfo = env.get(ENV_kEYS.userInfo);
  try {
    if (userInfo.locale && userInfo.country) {
      const locale = countryLocalMap(userInfo.country, userInfo.locale);
      await init(locale, userInfo.country);
      setUserTimezone();
    } else {
      setDefaultElvishConfig();
    }
  } catch (e) {
    console.error(e);
    setDefaultElvishConfig();
  }
}

/**
 * @name 设置时区，判断时区存在并且有效。
 * @desc 时区无效，设置首都时区
 * @desc 获取首都时区失败时，采用兜底逻辑
 */
function setUserTimezone() {
  const userInfo = env.get(ENV_kEYS.userInfo);
  const { country = '', timezone = '' } = userInfo;
  if (timezone && isSupportedTimezone(timezone)) {
    return setTimezone(timezone);
  }
  const capitalCityInfo = getCapitalCity(country);
  if (capitalCityInfo && capitalCityInfo.timezone) {
    return setTimezone(capitalCityInfo.timezone);
  }
  setDefaultElvishConfig();
}

/**
 * @name 兜底逻辑，用户无locale和country信息
 */
async function setDefaultElvishConfig() {
  await init(DEFAULT_CONFIG.LOCALE, DEFAULT_CONFIG.COUNTRY);
  setTimezone(DEFAULT_CONFIG.TIMEZONE);
}

export { initElvish, setUserTimezone };
